"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _classnames = _interopRequireDefault(require("classnames"));
var _humanizePlus = _interopRequireDefault(require("humanize-plus"));
var _ui = require("@unite-us/ui");
var _components = require("./components");
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Filter = exports["default"] = /*#__PURE__*/function (_Component) {
  _inherits(Filter, _Component);
  var _super = _createSuper(Filter);
  function Filter(props) {
    var _this;
    _classCallCheck(this, Filter);
    _this = _super.call(this, props);
    _this.filterOptions = _this.filterOptions.bind(_assertThisInitialized(_this));
    _this.onButtonClick = _this.onButtonClick.bind(_assertThisInitialized(_this));
    _this.onClearAll = _this.onClearAll.bind(_assertThisInitialized(_this));
    _this.onClickOutside = _this.onClickOutside.bind(_assertThisInitialized(_this));
    _this.onOptionChange = _this.onOptionChange.bind(_assertThisInitialized(_this));
    _this.setSelectedOptions = _this.setSelectedOptions.bind(_assertThisInitialized(_this));
    _this.onSearchChange = _this.onSearchChange.bind(_assertThisInitialized(_this));
    _this.onSelectAll = _this.onSelectAll.bind(_assertThisInitialized(_this));
    _this.getAvailableOptions = _this.getAvailableOptions.bind(_assertThisInitialized(_this));
    _this.setActiveFiltersAndOptionsCount = _this.setActiveFiltersAndOptionsCount.bind(_assertThisInitialized(_this));
    _this.setAvailableAndSelectedOptions = _this.setAvailableAndSelectedOptions.bind(_assertThisInitialized(_this));
    _this.asyncFilterOptions = _this.asyncFilterOptions.bind(_assertThisInitialized(_this));
    _this.debouncedAsyncFilterOptions = _lodash["default"].debounce(_this.asyncFilterOptions, props.asyncSearchDebounce);
    _this.state = {
      activeFilters: (0, _utils.getInitialFilters)(props.options),
      availableOptions: [],
      filterKey: props.filterKey,
      loading: false,
      open: false,
      options: props.options,
      search: '',
      selectedOptions: [],
      totalOptionsCount: (0, _utils.countOptions)(props.options)
    };
    return _this;
  }
  _createClass(Filter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.onClickOutside);
      this.filterOptions();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.state.open && !_lodash["default"].isEqual(this.props.options, prevProps.options)) {
        this.setActiveFiltersAndOptionsCount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        open: false
      });
      document.removeEventListener('click', this.onClickOutside);
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick(e) {
      e.preventDefault();
      if (!this.state.open) {
        this.searchField.resetValue();
      }
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "onClickOutside",
    value: function onClickOutside(e) {
      if (this.state.open) {
        var path = e.path || e.composedPath && e.composedPath();
        var index = _lodash["default"].findIndex(path, this.filterWrapper);
        if (path && index < 0) {
          this.setState({
            open: false
          });
        }
      }
    }
  }, {
    key: "onOptionChange",
    value: function onOptionChange(filter, value) {
      var _this2 = this;
      var optValue = filter.value;
      var newFilters = _lodash["default"].without(this.state.activeFilters, optValue);
      var newSelected = _lodash["default"].without(this.state.selectedOptions, filter);
      if (this.props.isSingleOptionSelect && value != null) {
        newFilters = [optValue];
        newSelected = [filter];
      } else if (value) {
        newFilters = newFilters.concat(optValue);
        newSelected = newSelected.concat(filter);
      }
      this.setState({
        activeFilters: newFilters,
        selectedOptions: newSelected
      }, function () {
        _this2.props.onFiltersChange(newFilters, _this2.props.filterKey, {
          setSelectedOptions: _this2.setSelectedOptions,
          filterKey: optValue
        });
        _this2.filterOptions();
      });
    }
  }, {
    key: "onSelectAll",
    value: function onSelectAll() {
      var _this3 = this;
      var options = this.state.options;
      if ((0, _utils.isMultiLevel)(options)) {
        options = (0, _utils.buildOptions)({
          options: options,
          selected: this.state.activeFilters
        });
      }
      var newFilters = _lodash["default"].reduce(options, function (acc, o) {
        if (_lodash["default"].get(o, 'hasChildren', false)) {
          return acc;
        }
        return _lodash["default"].concat(acc, o.value);
      }, []);
      this.setState({
        activeFilters: newFilters
      }, function () {
        _this3.filterOptions();
        _this3.props.onFiltersChange(newFilters, _this3.props.filterKey, {
          setSelectedOptions: _this3.setSelectedOptions
        });
      });
    }
  }, {
    key: "onClearAll",
    value: function onClearAll() {
      var _this4 = this;
      var newFilters = [];
      this.setState({
        activeFilters: newFilters
      }, function () {
        _this4.filterOptions();
        _this4.props.onFiltersChange(newFilters, _this4.props.filterKey, {
          setSelectedOptions: _this4.setSelectedOptions
        });
      });
    }
  }, {
    key: "onSearchChange",
    value: function onSearchChange(value) {
      var asyncSearch = this.props.asyncSearch;
      var search = this.state.search;
      if (asyncSearch) {
        if (search !== value) {
          return this.setState({
            search: value || '',
            loading: true,
            availableOptions: []
          }, this.debouncedAsyncFilterOptions);
        }
      }
      return this.setState({
        search: value || ''
      }, this.filterOptions);
    }
  }, {
    key: "setSelectedOptions",
    value: function setSelectedOptions(options) {
      var _this5 = this;
      var activeFilters = options;
      var selectedOptions = options.map(function (id) {
        return _this5.state.options.find(function (o) {
          return o.value === id;
        });
      });
      this.setState({
        activeFilters: activeFilters,
        selectedOptions: selectedOptions
      }, function () {
        _this5.filterOptions();
      });
    }
  }, {
    key: "getAvailableOptions",
    value: function getAvailableOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if ((0, _utils.isMultiLevel)(options)) {
        return (0, _utils.buildOptions)({
          options: options,
          selected: this.state.activeFilters
        });
      }
      return options;
    }
  }, {
    key: "setActiveFiltersAndOptionsCount",
    value: function setActiveFiltersAndOptionsCount() {
      var options = this.props.options;
      this.setState({
        activeFilters: (0, _utils.getInitialFilters)(options),
        options: options,
        totalOptionsCount: (0, _utils.countOptions)(options)
      }, this.filterOptions);
    }
  }, {
    key: "setAvailableAndSelectedOptions",
    value: function setAvailableAndSelectedOptions() {
      var availableOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var _this$state = this.state,
        selectedOptions = _this$state.selectedOptions,
        activeFilters = _this$state.activeFilters;
      var available = _lodash["default"].filter(availableOptions, function (opt) {
        return _lodash["default"].indexOf(activeFilters, opt.value) < 0;
      });
      var canBeSelectedOptions = _lodash["default"].uniqBy([].concat(_toConsumableArray(selectedOptions), _toConsumableArray(options)), 'value');
      var selected = _lodash["default"].filter(canBeSelectedOptions, function (opt) {
        return _lodash["default"].indexOf(activeFilters, opt.value) >= 0;
      });
      this.setState({
        availableOptions: this.props.optionsRenderLimit < 0 ? available : _lodash["default"].take(available, this.props.optionsRenderLimit),
        selectedOptions: selected,
        loading: false
      });
    }
  }, {
    key: "asyncFilterOptions",
    value: function asyncFilterOptions() {
      var _this6 = this;
      var asyncSearch = this.props.asyncSearch;
      var search = this.state.search;
      return asyncSearch(search).then(function (options) {
        var available = _this6.getAvailableOptions(options);
        _this6.setAvailableAndSelectedOptions(available, options);
        _this6.setState({
          options: options
        });
        return options;
      })["catch"](function (error) {
        _this6.setAvailableAndSelectedOptions([], []);
        return error;
      });
    }
  }, {
    key: "filterOptions",
    value: function filterOptions() {
      var options = this.state.options;
      if ((0, _utils.isMultiLevel)(options)) {
        options = (0, _utils.buildOptions)({
          options: options,
          selected: this.state.activeFilters
        });
      }
      var available = options;
      if (!_lodash["default"].isEmpty(this.state.search)) {
        var filterSearchOptions = this.props.filterSearchOptions;
        var search = this.state.search;
        var filteredOptions = filterSearchOptions ? filterSearchOptions(this.state.options, search) : (0, _utils.filterOptions)(this.state.options, search);
        options = filteredOptions;
        available = this.getAvailableOptions(filteredOptions);
      }
      this.setAvailableAndSelectedOptions(available, options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      var _this$props = this.props,
        asyncLoadingText = _this$props.asyncLoadingText,
        className = _this$props.className,
        hideSelectAll = _this$props.hideSelectAll,
        mustHaveOneSelected = _this$props.mustHaveOneSelected,
        name = _this$props.name,
        noMatchesPlaceholder = _this$props.noMatchesPlaceholder,
        optionsRenderLimit = _this$props.optionsRenderLimit,
        pluralName = _this$props.pluralName,
        searchPlaceholder = _this$props.searchPlaceholder,
        uniqIdPrefix = _this$props.uniqIdPrefix,
        dataTestId = _this$props.dataTestId;
      var _this$state2 = this.state,
        activeFilters = _this$state2.activeFilters,
        availableOptions = _this$state2.availableOptions,
        loading = _this$state2.loading,
        open = _this$state2.open,
        search = _this$state2.search,
        selectedOptions = _this$state2.selectedOptions,
        totalOptionsCount = _this$state2.totalOptionsCount;
      var filterClass = function filterClass() {
        return (0, _classnames["default"])({
          'ui-filter': true
        }, className);
      };
      var allOptionsSelected = activeFilters.length >= totalOptionsCount;
      var noMatchesFound = availableOptions.length <= 0;
      var filterButtonClass = function filterButtonClass() {
        return (0, _classnames["default"])({
          open: open
        });
      };
      var dropdownClass = function dropdownClass() {
        return (0, _classnames["default"])({
          dropdown: true,
          open: open
        });
      };
      var countClass = function countClass() {
        return (0, _classnames["default"])({
          'count-container': true,
          hidden: selectedOptions.length === 0
        });
      };
      var count = selectedOptions.length;
      var accessibilityLabel = "".concat(_humanizePlus["default"].titleCase(_humanizePlus["default"].pluralize(count || 1, name, pluralName)), " (").concat(count, ") selected, dropdown");
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: filterClass(),
        id: (0, _utils.createFilterId)(name),
        ref: function ref(filterWrapper) {
          _this7.filterWrapper = filterWrapper;
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        role: "listbox",
        onClick: this.onButtonClick,
        className: filterButtonClass(),
        "aria-label": accessibilityLabel,
        "data-testid": dataTestId
      }, _humanizePlus["default"].titleCase(_humanizePlus["default"].pluralize(count || 1, name, pluralName)), /*#__PURE__*/_react["default"].createElement("span", {
        className: countClass()
      }, "(", /*#__PURE__*/_react["default"].createElement("span", {
        className: "count"
      }, count), ")")), /*#__PURE__*/_react["default"].createElement("div", {
        className: dropdownClass()
      }, /*#__PURE__*/_react["default"].createElement(_components.Search, {
        id: (0, _utils.createFilterId)(name),
        label: "Search ".concat(name),
        onChange: this.onSearchChange,
        placeholder: searchPlaceholder,
        ref: function ref(searchField) {
          _this7.searchField = searchField;
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-filter__options"
      }, !_lodash["default"].isEmpty(selectedOptions) ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "selected-options__container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "selected-options"
      }, selectedOptions.map(function (o) {
        return /*#__PURE__*/_react["default"].createElement(_ui.SelectionBubble, {
          key: "uOpt-".concat(o.value, "-selected"),
          label: o.label,
          hideClose: mustHaveOneSelected && count === 1,
          selected: o,
          onClick: _this7.onOptionChange
        });
      })), mustHaveOneSelected ? /*#__PURE__*/_react["default"].createElement("div", {
        className: 'has-border'
      }) : /*#__PURE__*/_react["default"].createElement(_components.ClearSelections, {
        onClick: this.onClearAll,
        allOptionsSelected: allOptionsSelected
      })) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "filter-options__container"
      }, loading && /*#__PURE__*/_react["default"].createElement("div", {
        className: "filter-options__container--loading"
      }, asyncLoadingText), /*#__PURE__*/_react["default"].createElement(_components.SelectAll, {
        hide: hideSelectAll || noMatchesFound || allOptionsSelected || optionsRenderLimit > 0,
        onSelectAll: this.onSelectAll
      }), this.state.availableOptions.map(function (o) {
        return /*#__PURE__*/_react["default"].createElement(_components.FilterOption, {
          selected: _lodash["default"].indexOf(activeFilters, o.value) >= 0,
          key: "uOpt-".concat(o.value),
          onChange: _this7.onOptionChange,
          option: o,
          searchTerm: search,
          uniqIdPrefix: uniqIdPrefix
        });
      }), /*#__PURE__*/_react["default"].createElement(_components.NoMatches, {
        noMatchesFound: !loading && (allOptionsSelected || noMatchesFound),
        placeholder: noMatchesPlaceholder
      })))));
    }
  }]);
  return Filter;
}(_react.Component);
Filter.propTypes = {
  /** className for reference */
  className: _propTypes["default"].string,
  /** Filter key used when storing selected filter to state. i.e. serviceTypes */
  filterKey: _propTypes["default"].string,
  /** returns an array of filtered searched ServiceType options */
  filterSearchOptions: _propTypes["default"].func,
  /** Don't allow user to remove all options */
  mustHaveOneSelected: _propTypes["default"].bool,
  /** Should hide select all button */
  hideSelectAll: _propTypes["default"].bool,
  /** Only allows one option to be selected at a time */
  isSingleOptionSelect: _propTypes["default"].bool,
  /** Singular name to display on Filter button (i.e. 'Population') */
  name: _propTypes["default"].string.isRequired,
  /** Plural name to display on Filter in case Humanize can't handle it */
  pluralName: _propTypes["default"].string,
  /**
   * @param {array} activeFilters array of selected filters
   * @param {string} key filterKey
   * @public
  */
  onFiltersChange: _propTypes["default"].func.isRequired,
  /**
   * Accepts Promise resolving an array of formatted options
   * @param {string} search
  */
  asyncSearch: _propTypes["default"].func,
  /** Debouce wait for the asyncSearch */
  asyncSearchDebounce: _propTypes["default"].number,
  /** Async loading text displayed while waiting for the promise */
  asyncLoadingText: _propTypes["default"].string,
  /** Array of filter options objects */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired,
    initial: _propTypes["default"].bool,
    children: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired,
      initial: _propTypes["default"].bool
    }))
  })).isRequired,
  /** Maximum number of options to render in case of long options array (-1 is unlimited) */
  optionsRenderLimit: _propTypes["default"].number,
  /** Placeholder text for when no matches are found */
  noMatchesPlaceholder: _propTypes["default"].string,
  /** Placeholder text for search */
  searchPlaceholder: _propTypes["default"].string,
  /** A prefix to prevent ID conflicts when multiple filters share the same option list */
  uniqIdPrefix: _propTypes["default"].string,
  /** Immutable identifier for testing */
  dataTestId: _propTypes["default"].string
};
Filter.defaultProps = {
  className: '',
  filterKey: '',
  filterSearchOptions: undefined,
  asyncSearch: undefined,
  mustHaveOneSelected: false,
  hideSelectAll: false,
  isSingleOptionSelect: false,
  optionsRenderLimit: -1,
  noMatchesPlaceholder: 'No Results Found',
  pluralName: null,
  searchPlaceholder: 'Search',
  uniqIdPrefix: '',
  asyncSearchDebounce: 400,
  asyncLoadingText: 'Loading...',
  dataTestId: ''
};